import api from '../util/api'
import * as  divisaoComissaoActions from '../store/modules/divisaoComissao/actions'
import { notifySuccess, notifyWarn } from '../components/message/message'
import { maskDate } from '../util/masks'
import { setLoading } from '../store/modules/globalLoading/actions'
import store from '../store'

function recarregarLista() {
    const { search, getAllItems } = store.getState().divisaoComissao
    get(search, getAllItems.tamanhoPagina || 10, 1)
}

export function limparBusca() {
    divisaoComissaoActions.cleanSearch()
    recarregarLista()
}

function isPercentualValido(percentual) {
    return Number.isFinite(percentual) && percentual >= 0 && percentual <= 100
}

function validarItens(itens) {
    if (itens.some((item) => !isPercentualValido(Number(item.percentual)))) {
        notifyWarn('O percentual de comissão de cada item deve estar entre 0 e 100')
        return false
    }
    return true
}

function montarItens(itens) {
    return itens.map((item) => ({
        id: item.id ?? null,
        tiposComissaoId: item.tiposComissaoId,
        percentual: Number(item.percentual),
    }))
}

export async function get(search, pageSize, page) {

    var url = `divisaoComissao?pagina=${page}&registros=${pageSize}`

    if (search.banco !== '0') url = url + `&bancoId=${search.banco}`
    if (search.lojaId !== '0') url = url + `&lojaId=${search.lojaId}`
    if (search.lojaMatrizId !== '0') url = url + `&lojaMatrizId=${search.lojaMatrizId}`
    if (search.dataInicio) url = url + `&dtInicio=${search.dataInicio}`
    if (search.dataFim) url = url + `&dtFim=${search.dataFim}`

    if (search.dataInicio && search.dataFim) {
        if (search.dataFim < search.dataInicio) {
            return notifyWarn('Data inicial não pode ser maior que data final')
        }
    }

    setLoading(true)
    const data = await api.get(url)
    setLoading(false)

    if (!data.success) {
        return
    }

    data.content.registros.forEach((registro) => {
        registro.dtInicio = maskDate(registro.dtInicio, 'DD-MM-YYYY')
        registro.dtFim = registro.dtFim && maskDate(registro.dtFim, 'DD-MM-YYYY')
    })

    divisaoComissaoActions.getItems(data.content.registros)
    divisaoComissaoActions.getAllItems({ 
        quantidade: data.content.quantidade, 
        quantidadeTotal: data.content.quantidadeTotal, 
        totalPaginas: data.content.totalPaginas,
        tamanhoPagina: data.content.tamanhoPagina,
        pagina: page })
}

export async function getBancos() {
    const data = await api.get(`bancos`)

    if (!data.success) {
        return
    }

    divisaoComissaoActions.setBancos(data.content)
}

export async function getLojas(filtros) {
    let url = `lojas/lojas-que-possui-master-divisao?`
    
    if (filtros.bancoId === '0') delete filtros.bancoId
  
    let searchParams = new URLSearchParams(filtros).toString();
    url = url + searchParams
  
    divisaoComissaoActions.setLoadingLoja(true)
    const data = await api.get(url)
    divisaoComissaoActions.setLoadingLoja(false)

    if (!data.success) {
        return
    }
    divisaoComissaoActions.setLojas(data.content ?? [])
}

export async function getLojasMatrizes(filtros) {
    let url = `lojas/lojas-master-que-possui-divisao?`

    if (filtros.bancoId === '0') delete filtros.bancoId
  
    let searchParams = new URLSearchParams(filtros).toString();
    url = url + searchParams
  
    divisaoComissaoActions.setLoadingLojaMatriz(true)
    const data = await api.get(url)
    divisaoComissaoActions.setLoadingLojaMatriz(false)

    if (!data.success) {
        return
    }
    divisaoComissaoActions.setLojasMatrizes(data.content ?? [])
}

export async function getLojasMatrizesRegister(idBanco) {
    setLoading(true)
    const data = await api.get(`lojas/matriz?bancoId=${idBanco}`)
    setLoading(false)

    if (!data.success) {
        return
    }

    divisaoComissaoActions.setLojasMatrizesRegister(data.content ?? [])
}

export async function getLojasSemDivisaoRegister(idBanco) {
    setLoading(true)
    const data = await api.get(`lojas/lojas-que-possuem-master/${idBanco}`)
    setLoading(false)

    if (!data.success) {
        return
    }

    divisaoComissaoActions.setLojasBanco(data.content ?? [])
}

export async function getTiposComissao(idBanco) {
    setLoading(true)
    const data = await api.get(`TipoComissao/GetByInstituicao?idInstituicao=${idBanco}`)
    setLoading(false)

    if (!data.success) {
        return
    }

    divisaoComissaoActions.setTiposComissao(data.content)
    return data.content
}

export async function getLojasRegister(idBanco) {
    setLoading(true)
    const data = await api.get(`lojas/filiais?bancoId=${idBanco}`)
    setLoading(false)

    if (!data.success) {
        return
    }

    divisaoComissaoActions.setLojasRegister(data.content ?? [])
}

export async function getById(id) {

    setLoading(true)
    const data = await api.get(`divisaoComissao/${id}`)
    setLoading(false)

    if (!data.success) {
        return false
    }

    let tiposComissao = await getTiposComissao(data.content.banco.id)

    if (!tiposComissao) {
        tiposComissao = []
        notifyWarn('Não foi possível carregar os tipos de comissão da instituição')
    }

    data.content.divisaoComissaoItens.forEach((item) => {
        var tipoComissao = tiposComissao.find((tipoComissao)=> tipoComissao.id === item.tiposComissaoId)
        item.tipoComissaoId= item.tiposComissaoId;
        item.tipoComissao = tipoComissao?.descricao
    })

    let dataFormated = {
        id: data.content.id,
        bancoId: data.content.banco.id,
        lojaBancoId: data.content.lojaBanco.id,
        matriz: data.content.lojaBanco.nomeMaster,
        dataInicio: maskDate(data.content.dtInicio,'YYYY-MM-DD'),
        dataFim: maskDate(data.content.dtFim, 'YYYY-MM-DD'),
        divisaoComissaoItens: data.content.divisaoComissaoItens,
        idsItensOriginais: data.content.divisaoComissaoItens.map((item) => item.id)
    }

    divisaoComissaoActions.item(dataFormated)
    return true
}

export async function create(item) {

    if (item.bancoId === '0') {
        return notifyWarn('Selecione uma instituição')
    }

    if (item.dataInicio === '') {
        return notifyWarn('Selecione uma data de início da vigência')
    }

    if (item.dataFim === '') {
        return notifyWarn('Selecione uma data de fim da vigência')
    }

    if (item.dataInicio >= item.dataFim) {
        return notifyWarn('A data final deve ser maior que a data inicial')
    }

    if (item.lojaBancoId === '0') {
      return notifyWarn('O campo Loja Banco é obrigatório')
    }

    if (!validarItens(item.divisaoComissaoItens)) {
        return
    }

    let dataCreate = {
        bancoId: item.bancoId,
        lojaBancoId: item.lojaBancoId,
        dtInicio: item.dataInicio,
        dtFim: item.dataFim,
        divisaoComissaoItens: montarItens(item.divisaoComissaoItens)
    }

    setLoading(true)
    const data = await api.post('divisaoComissao', dataCreate)
    setLoading(false)

    if (!data.success) {
        return
    }

    divisaoComissaoActions.cleanRegister()
    notifySuccess('Parametrização de divisão de comissão cadastrada')
    recarregarLista()
}

export async function remove(id) {
    setLoading(true)
    const data = await api.delete(`divisaoComissao?id=${id}`)
    setLoading(false)

    if (!data.success) {
        return
    }

    notifySuccess('Registro excluído')
    recarregarLista()
}

export async function update(item) {

    if (item.dataInicio === '') {
        return notifyWarn('Selecione uma data de início da vigência')
    }

    if (item.dataFim === '') {
        return notifyWarn('Selecione uma data de fim da vigência')
    }

    if (item.dataInicio >= item.dataFim) {
        return notifyWarn('A data final deve ser maior que a data inicial')
    }

    if (!validarItens(item.divisaoComissaoItens)) {
        return
    }

    const itensExistentes = item.divisaoComissaoItens.filter((divisao) => divisao.id)
    const itensNovos = item.divisaoComissaoItens.filter((divisao) => !divisao.id)
    const idsRemovidos = (item.idsItensOriginais || []).filter(
        (id) => !itensExistentes.some((divisao) => divisao.id === id)
    )

    let dataUpdate = {
        id: item.id,
        bancoId: item.bancoId,
        dtInicio: item.dataInicio,
        dtFim: item.dataFim,
        divisaoComissaoItens: montarItens(itensExistentes)
    }

    setLoading(true)
    const data = await api.put(`divisaoComissao/${item.id}`, dataUpdate)

    if (!data.success) {
        setLoading(false)
        return
    }

    let houveFalhaNosItens = false

    for (const id of idsRemovidos) {
        const resposta = await api.delete(`divisaoComissao/deleteItem?id=${id}`)
        if (!resposta.success) houveFalhaNosItens = true
    }

    for (const novo of itensNovos) {
        const resposta = await api.post('divisaoComissao/item', {
            divisaoComissaoId: item.id,
            tiposComissaoId: novo.tiposComissaoId,
            percentual: Number(novo.percentual)
        })
        if (!resposta.success) houveFalhaNosItens = true
    }
    setLoading(false)

    if (houveFalhaNosItens) {
        notifyWarn('A divisão foi atualizada, mas alguns itens não puderam ser incluídos ou removidos. Confira os itens.')
        await getById(item.id)
        recarregarLista()
        return
    }

    divisaoComissaoActions.cleanRegister()
    divisaoComissaoActions.setActiveTab('Search')
    notifySuccess('Parametrização de divisão de comissão atualizada')
    recarregarLista()
}